const shortTimeOptions = {
    hour: 'numeric',
    minute: 'numeric',
};
const modifiedShortTimes = {
    tr: (date) => new Intl.DateTimeFormat('tr', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(date),
};
/**
 * Function that returns short time format approved by Wix Localization team.
 * @param locale - language/country short value that is passed to Intl.DateTimeFormat
 * @param date - JavaScript Date objects represent a single moment in time in a platform-independent format.
 */
export const getShortTime = (locale, date) => {
    if (modifiedShortTimes[locale]) {
        return modifiedShortTimes[locale]?.(date);
    }
    return new Intl.DateTimeFormat(locale, shortTimeOptions).format(date);
};
//# sourceMappingURL=getShortTime.js.map